import { Editor, Text } from 'slate'
import { ElementWithType } from '../../../../../../utils/types'

export const disableOnCodeChild = ({ editor }) => {
  const [code] = Editor.nodes(editor, {
    match: (n: ElementWithType) => n.type === 'code',
    mode: 'lowest'
  })
  return Boolean(code)
}

export const insertBlockTextInsideCode = (data, editor) =>{
  try{
      const [node] = Editor.node(editor, editor.selection)
      if(!node || !Text.isText(node)) return
      const [parentNode] = Editor.parent(editor, editor.selection)
      if(!parentNode || parentNode["type"] !== 'code') return
      if(data.types.length === 1 && data.types.includes('text/plain')) {
          const text = data.getData('text/plain')
          editor.insertText(text)
          return true
      }
  }catch(e){console.warn(e)}
}
